import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-rhino-black pt-20" data-id="element-98">
      <div className="absolute inset-0 bg-rhino-black" data-id="element-99"></div>

      <div className="container mx-auto px-6 relative z-10 flex flex-col items-center text-center" data-id="element-100">
        <FadeIn delay={0.1} data-id="element-101">
          <div className="w-full max-w-2xl mx-auto mb-10 rounded-lg overflow-hidden shadow-2xl shadow-rhino-gold/10" data-id="element-102">
            <img src="https://cdn.magicpatterns.com/uploads/dUr1zVjET8f8eS1pyCRf18/1000081017.jpg" alt="Three rhinos charging forward" className="w-full h-auto object-cover" data-id="element-103" />
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-104">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-tight mb-6 tracking-tight" data-id="element-105">
            THE MINDSET THAT <br className="hidden md:block" data-id="element-106" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rhino-gold to-yellow-200" data-id="element-107">
              IGNITES THE CHARGE.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-108">
          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto mb-10" data-id="element-109">
            Discipline. Strength. Purpose. The charge starts now.
          </p>
        </FadeIn>

        <FadeIn delay={0.7} data-id="element-110">
          <motion.a href="#community" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="px-10 py-5 bg-rhino-gold text-rhino-black font-heading font-bold text-lg tracking-wider uppercase rounded shadow-[0_0_20px_rgba(212,160,23,0.3)] hover:shadow-[0_0_30px_rgba(212,160,23,0.5)] hover:bg-rhino-gold-hover transition-all" data-id="element-111">
            Follow the Movement — Join The Rhino Crash
          </motion.a>
        </FadeIn>
      </div>
    </section>;
}